export default __webpack_public_path__ + "static/media/Landnobg.e6e1dfce.gif";